/** Site-wide max upload size (images and other file uploads). */
export const MAX_UPLOAD_FILE_MB = 16;
export const MAX_UPLOAD_FILE_BYTES = MAX_UPLOAD_FILE_MB * 1024 * 1024;

/**
 * @param {File|Blob|null|undefined} file
 * @returns {string|null} Error message, or null if OK / no file.
 */
export function getUploadSizeError(file) {
  if (!file || typeof file.size !== "number") return null;
  if (file.size <= MAX_UPLOAD_FILE_BYTES) return null;
  const sizeMb = (file.size / (1024 * 1024)).toFixed(1);
  return `File is too large (${sizeMb} MB). Maximum size is ${MAX_UPLOAD_FILE_MB} MB.`;
}

/** @returns {boolean} true if file is within the limit (missing size = allow). */
export function isUploadWithinSizeLimit(file) {
  return !getUploadSizeError(file);
}
